import React from "react";
import { SITE_CONTENT } from "../content";
import rightVeggies from "../assets/background/home_three_about_bg.png";

const OurStorySection = () => {
  const content = SITE_CONTENT.pages.homePage.aboutSection;

  return (
    <section className="relative bg-white py-24 text-gray-800 overflow-hidden">
      {/* Top ZigZag Border */}
      <div
        className="absolute top-0 left-0 w-full h-[15px] z-20"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='15'%3E%3Cpolygon points='0,15 10,0 20,15' fill='%23ffffff'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat-x",
          backgroundSize: "20px 15px",
          transform: "translateY(-100%)",
        }}
      />
      <img
        src={rightVeggies}
        alt="Fresh Tomatoes"
        className="absolute bottom-0 right-0 w-full object-cover mix-blend-multiply opacity-90 pointer-events-none"
      />

      <div className="max-w-6xl mx-auto px-6 lg:px-10 relative z-30">
        <h2 className="text-center text-6xl md:text-[5rem] font-['Dancing_Script'] text-[#cd3a27] mb-12">
          Our Story
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 text-sm text-gray-600 leading-relaxed max-w-4xl mx-auto">
          {/* Paragraph 1 with Drop Cap */}
          <div className="relative">
            <span className="float-left text-7xl md:text-[5.5rem] font-bold text-gray-600 mr-4 mt-2 leading-[0.75] font-serif">
              {content.paragraphs[0].charAt(0)}
            </span>
            <p className="text-justify font-medium pt-1 relative z-10">
              {content.paragraphs[0].substring(1)}
            </p>
          </div>

          {/* Paragraph 2 */}
          <div>
            <p className="text-justify font-medium pt-1 relative z-10">
              {content.paragraphs[1]}
            </p>
          </div>
        </div>

        {/* Signature */}
        <div className="flex justify-center mt-12 md:mt-16 relative z-10">
          <div className="font-['Dancing_Script'] text-[2.5rem] text-gray-800 -rotate-3">
            Combo Box
          </div>
        </div>
      </div>

      {/* Bottom ZigZag Border */}
      <div
        className="absolute bottom-0 left-0 w-full h-[15px] z-20"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='15'%3E%3Cpolygon points='0,0 10,15 20,0' fill='%23ffffff'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat-x",
          backgroundSize: "20px 15px",
          transform: "translateY(100%)",
        }}
      />
    </section>
  );
};

export default OurStorySection;
